import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import ReactDOM from 'react-dom';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import MasterCardRegistration from './MasterCardRegistration';

export default class MasterCardRegistrationComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <ReduxProvider store={store}>
                <MasterCardRegistration options={this.options} />
            </ReduxProvider>,
            this.element
        );
    }
}
